
import { User } from '@/@types/responses/user/User'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AuditInformation',
  props: {
    createdByUser: {
      type: User,
      required: true
    },
    createdDate: {
      type: String,
      required: true
    },
    lastModifiedByUser: {
      type: User,
      required: true
    },
    lastModifiedDate: {
      type: String,
      required: true
    }
  }
})
